//colors
export const colors = {
  primary: "#046CEC",
  success: "#08BA36",
  success_1: "rgba(8, 186, 54, .1)",
  error: "#F30028",
  error_1: "rgba(243, 0, 40, .1)",
  white: "#FFFFFF",
  warning: "#F30028",
  yellow: "#F1AC06",
  yellow_1: "rgba(241, 172, 6, .1)",
  main_text_color: "#000000",
  secondary_text_color: "#F8F8F8",
  heading_color: "#000514",
  input_border_color_primary: "#E9F2FD",
  icon_button_border_color: "#E3EEFC",
  input_border_focus_color_primary: "#08BA36",
  dropdown_item_border_color: "#046CEC1A",
  button_grey_bg: "#7D90A8",
  main_bg:
    "transparent linear-gradient(0deg, #046CEC 0%, #F3F5F7 70%, #F3F5F7 100%) 0% 0% no-repeat padding-box",
}

//font-sizes
export const fontSizes = {
  xs: "10px",
  s: "11px",
  base: "12px",
  ms: "13px",
  m: "14px",
  ml: "15px",
  l: "16px",
  xl: "18px",
  xxl: "20px",
  xxxl: "24px"
}

// spacing  margin ,padding
export const spacing = {
  mr_xs: "16px",
  mr_base: "20px",
  mr_s: "28px",
  mr_ms: "31px",
  mr_m: "40px",
  mr_ml: "45px",
  mr_l: "53px",
  mr_xl: "60px",
  mr_xxl: "109px",
  pd_xs: "16px",
  pd_base: "15px",
  pd_s: "18px",
  pd_ms: "20px",
  pd_m: "22px",
  pd_ml: "26px",
  pd_l: "30px",
  pd_xl: "32px",
  pd_xxl: "40px",
}

// borders
export const borders = {
  base: "2px solid",
}

//border radius
export const radii = {
  xxs: "4px",
  xs: "8px",
  base: "10px",
  s: "12px",
  m: "20px",
  ml: "30px",
  l: "40px",
  xl: "100px",
}

//box shadow
export const shadows = {
  primary: "0px 15px 30px #046CEC1A",
  secondary: "0px 2px 10px #046CEC1A",
  tertiary: "0px 10px 20px #046CEC26",
  map_button_shadow: "0px 3px 16px #046CEC26"
}

export const lineHeights = {
  heading: "28px",
}

// container size
export const containerSize = {
  wd_xs: "435px",
  wd_s: "500px",
  wd_sm: "540px",
  wd_ml: "549px",
  wd_l: "560px",
  wd_xl: "566px",
  wd_xxl: "660px",
  wd_base: "974px",
  hg_xxs: "300px",
  hg_xs: "398px",
  hg_s: "440px",
  hg_ms: "488px",
  hg_m: "547px",
  hg_base: "554px",
  hg_ml: "565px",
  hg_l: "606px",
  hg_xl: "625px",
  hg_xxl: "770px",
}

export const sizes = {}

// widths
export const widths = {
  qapp_logo_width: "140px",
  dashboard_card_width: "180px",  
  employee_card_width: "60px",
  container_xl: "1192px",
  container_lg: "974px",
  container_base: "100%",
}

// heights
export const heights = {
  qapp_logo_height: "140px",
  dashboard_card_height: "180px",
  employee_card_height: "60px",
}
